export * from './lib/useMediaQuery'
export { default } from './lib/useMediaQuery'
